<template>
  <div class="view">
    <div class="token">{{ data[propName] || '' }}</div>
    <sc-btn
        v-show="info.status === 'edit'"
        :confirm="data[propName] ? '确定要重新生成吗？' : undefined"
        :handler="regenerate"
        style="margin-right: 8px"
        size="small"
        :text="data[propName] ? '重新生成' : '生成'"
    />
    <sc-btn
        v-show="data[propName]"
        ref="btn"
        :data-clipboard-text="data[propName] || ''"
        :handler="onCopy"
        size="small"
        text="复制"
        type="primary"
    />
  </div>
</template>

<script lang="ts" setup>
import {defineProps, onMounted, ref} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import ClipboardJS from "clipboard";
import {message} from "ant-design-vue";
import ScBtn from "@/components/common/widget/ScBtn.vue";
import {TokenFieldType} from "@/components/business/crud/interface/FieldType";
import _ from "lodash";

const props = defineProps<{
  propName: string;
  widget: TokenFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();
const btnRef = ref<InstanceType<typeof ScBtn>>();

onMounted(() => {
  if (btnRef.value) {
    new ClipboardJS(btnRef.value.$el);
  }
})

// 可以根据需要定义字符集合
const characters = '123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

async function regenerate() {
  data.value[props.propName] = _.sampleSize(characters, 26).join('')
}

function onCopy() {
  message.success('已复制');
}

</script>


<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
  display: flex;
}

.token {
  margin-right: 10px
}
</style>
